export const EDR_CHANNEL_CPR = 'problemReports';
export const EDR_CHANNEL_RCV_IN_MEETING_EVENT = 'rcvInMeetingEvents';
export const EDR_CHANNEL_CLIENT_INFO = 'rcvQosClientInfo';
export const EDR_CHANNEL_UTILIZATION = 'rcvQosUtilization';
export const EDR_CHANNEL_RATING = 'rcvQosUserRatings';

export const EDR_RCV_IN_MEETING_EVENTS = {
    SESSION_START: 'session_start',
    SESSION_FAILED: 'meeting_create_error',
    BRIDGE_CREATE_ERROR: 'bridge_create_error',
    BRIDGE_REQUEST_ERROR: 'bridge_request_error',
    MEDIA_WS_RECOVERY: 'media_ws_recovery',
    CHAT_META_FAIL: 'chat_meta_fail',
    SS_START_FAILED: 'ss_start_failed',
    NETWORK_DISCONNECT: 'network_disconnect',
    RCT_RECOVERY_HARD: 'cop_recovery_hard',
    RCT_RECOVERY_SOFT: 'cop_recovery_soft',
    RCT_RECOVERY_PING_TIMEOUT: 'cop_recovery_ping_timeout',
    RCT_PARTITION_SWITCHOVER_START: 'cop_partition_switchover_start',
    RCT_PARTITION_SWITCHOVER_SUCCESS: 'cop_partition_switchover_success',
    RCT_PARTITION_SWITCHOVER_FAILURE: 'cop_partition_switchover_failure',
    RCT_PARTITION_STORM: 'cop_partition_storm',
    RECOVERY_SUMMARY: 'recovery_summary',
    INMEETING_PROFILER_TRACK: 'inmeeting_profiler_track',
    MEDIA_TRAFFIC_BLOCKED: 'media_traffic_blocked',
    MEDIA_TRAFFIC_INTERRUPTED: 'media_traffic_interrupted',
    MEETING_FEATURE_FLAGS_SNAPSHOT: 'meeting_feature_flags_snapshot',
} as const;
